<!--
=========================================================
* Vue Argon Dashboard 2 - v3.0.0
=========================================================

* Product Page: https://creative-tim.com/product/vue-argon-dashboard-laravel
* Copyright 2022 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
-->
<template>
  <div v-show="this.$store.state.layout === 'landing'"
    class="landing-bg h-100 bg-gradient-primary position-fixed w-100"></div>
  <sidenav :custom_class="this.$store.state.mcolor" :class="[
    this.$store.state.isTransparent,
    this.$store.state.isRTL ? 'fixed-end' : 'fixed-start'
  ]" v-if="this.$store.state.showSidenav" />
  <main class="main-content position-relative max-height-vh-100 h-100 border-radius-lg">
    <!-- nav -->
    <navbar :class="[navClasses]" :textWhite="this.$store.state.isAbsolute ? 'text-white opacity-8' : 'text-white'
      " :minNav="navbarMinimize" v-if="this.$store.state.showNavbar" />
    <router-view />
    <app-footer v-show="this.$store.state.showFooter" />


    <configurator ref="configurator" :toggle="toggleConfigurator" :class="[
      this.$store.state.showConfig ? 'show' : '',
      this.$store.state.hideConfigButton ? 'd-none' : '',
      isCatalogRoute ? 'd-none' : ''
    ]" />

    <!-- Modulo Categoria -->
    <div class="modal fade" id="ModalCategory" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Categoria</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-4">
                  <input type="text" v-model="category.name" class="form-control" placeholder="Categoria">
                </div>
                <div class="col-4">
                  <select v-model="category.parent_id" class="form-select">
                    <option value="" selected>Seleccionar</option>
                    <option v-for="process in parents" :key="process.id" :value="process.id">
                      {{ process.name }}
                    </option>
                  </select>
                </div>
                <!-- Botón: muestra "+" si no se está editando; si se está editando, muestra editar y cancelar -->
                <div class="col-4">
                  <button v-if="!isEditingCategory" type="button" class="btn btn-primary" @click="submitCategory">
                    +
                  </button>
                  <div v-else>
                    <button type="button" class="btn btn-warning"
                      @click="submitCategory">
                      <i class="fa fa-edit fa-xs"></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style="margin-left: 5px;" @click="cancelEditCategory">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de categorías -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in categories"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>{{ value.fullname }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editCategory(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2"
                  @click="deleteCategory(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalCategory">Cerrar</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Modulo Color -->
    <div class="modal fade" id="ModalColors" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Color</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-4">
                  <input type="text" v-model="color.name" class="form-control" placeholder="Color" />
                </div>
                <div class="col-4">
                  <input type="text" v-model="color.ref" class="form-control" placeholder="Referencia" />
                </div>

                <div class="col-4">
                  <!-- Si NO estás editando, muestra el botón "+" -->
                  <button v-if="!isEditingColor" type="button" class="btn btn-primary" @click="submitColor">
                    +
                  </button>

                  <!-- Si SÍ estás editando, muestra boton de 'editar' y 'cancelar' -->
                  <div v-else>
                    <button type="button" class="btn btn-warning"
                      @click="submitColor">
                      <i class="fa fa-edit fa-xs" ></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style="margin-left: 5px;" @click="cancelEditColor">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de colores -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in colors"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>{{ value.name }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editColor(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteColors(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalColors">
              Cerrar
            </button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modulo Tallas -->
    <div class="modal fade" id="ModalTallas" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Talla</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-8">
                  <input type="text" v-model="sizeList.size" class="form-control" placeholder="Talla">
                </div>
                <!-- Botón: muestra "+" si NO se está editando; si se edita, muestra editar y cancelar -->
                <div class="col-4">
                  <button v-if="!isEditingTalla" type="button" class="btn btn-primary" @click="submitTalla">
                    +
                  </button>
                  <div v-else>
                    <button type="button" class="btn btn-warning" 
                      @click="submitTalla">
                      <i class="fa fa-edit fa-xs" ></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style="margin-left: 5px;" @click="cancelEditTalla">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de tallas -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in tallas"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>{{ value.size }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editTalla(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteTalla(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalTallas">Cerrar</button>
          </div>
        </div>
      </div>
    </div>



    <!-- Modulo Oficio -->
    <div class="modal fade" id="ModalOficios" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Oficio</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>
          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-8">
                  <input type="text" v-model="oficio.name" class="form-control" placeholder="Oficio">
                </div>

                <!-- Botón + si NO estás editando; Si SÍ estás editando, muestra Editar y Cancelar -->
                <div class="col-4">
                  <button v-if="!isEditingOficio" type="button" class="btn btn-primary" @click="submitOficio">+</button>
                  <div v-else>
                    <button type="button" class="btn btn-warning"
                      @click="submitOficio">
                      <i class="fa fa-edit fa-xs"></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style=" margin-left: 5px;" @click="cancelEditOficio">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-12">
                  <input type="number" min="0" step="any" v-model="oficio.price" class="form-control" placeholder="Valor a pagar por este oficio">
                </div>
              </div>
            </form>

            <!-- Listado de oficios -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in oficios"
              :key="value.id" style="padding: 3px 15px; margin: 2px;">
              <span>
                {{ value.name }}
                <span v-if="Number(value.price) > 0" class="badge badge-sm bg-success ms-1">${{ Number(value.price).toLocaleString('es-CO') }}</span>
              </span>
              <span>
                <a @click="editOficio(value)" >
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteOficios(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalOficios">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


    <!-- Modulo Bodega -->
    <div class="modal fade" id="ModalBodegas" tabindex="-1" role="dialog">
      <div class="modal-dialog">
        <div class="modal-content card">
          <div class="modal-header">
            <h5 class="modal-title">Agregar Bodega</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
          </div>

          <div class="modal-body">
            <form>
              <div class="row">
                <div class="col-8">
                  <input type="text" v-model="bodega.name" class="form-control" placeholder="Bodega">
                </div>
                <div class="col-4">
                  <!-- Si NO estás editando, muestra el botón "añadir" -->
                  <button v-if="!isEditing" type="button" class="btn btn-primary" @click="submitBodega">+</button>

                  <!-- Si estás editando, muestra botón "editar" y botón "X" (cancelar) -->
                  <div v-else>
                    <button type="button" class="btn btn-warning" 
                      @click="submitBodega">
                      <i class="fa fa-edit fa-xs" ></i>
                    </button>
                    <button type="button" class="btn btn-danger"
                      style="margin-left: 15px;" @click="cancelEditBodega">
                      <i class="fa fa-times fa-xs" ></i>
                    </button>
                  </div>
                </div>
              </div>
            </form>

            <!-- Listado de bodegas -->
            <div class="alert alert-light d-flex justify-content-between align-items-center" v-for="value in bodegas"
              :key="value.id" style="padding: 3px 15px;margin: 2px;">
              <span>{{ value.name }}</span>
              <span>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer" @click="editBodega(value)">
                  <i class="fa fa-edit"></i>
                </a>
                <a class="text-secondary font-weight-bold text-xs cursor-pointer ms-2" @click="deleteBodegas(value.id)">
                  <i class="fa fa-trash"></i>
                </a>
              </span>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="closeModalBodegas">Cerrar</button>
          </div>
        </div>
      </div>
    </div>


  </main>
</template>
<script>
import Sidenav from "./examples/Sidenav";
import Configurator from "@/examples/Configurator.vue";
import Navbar from "@/examples/Navbars/Navbar.vue";
import AppFooter from "@/examples/Footer.vue";
import { mapMutations } from "vuex";
import Swal from 'sweetalert2';
import * as bootstrap from 'bootstrap';


export default {
  name: "App",
  data() {
    return {
      category: {
        id: 0,
        name: '',
        parent_id: ''
      },
      color: {
        id: 0,
        name: '',
        ref: ''
      },
      oficio: {
        id: 0,
        name: '',
        description: '',
        status: 1,
        price: null,
      },
      bodega: {
        id: 0,
        name: '',
        description: '',
        status: 1,
      },
      sizeList: {
        id: 0,
        size: ''
      },
      categories: [],
      parents: [],
      colors: [],
      oficios: [],
      bodegas: [],
      tallas: [],
    }
  },
  components: {
    Sidenav,
    Configurator,
    Navbar,
    AppFooter
  },
  watch: {
    '$route.path'(path) {
      const isCatalog = path.startsWith('/catalogo/');
      this.$store.state.showSidenav = !isCatalog;
      this.$store.state.showNavbar = !isCatalog;
      this.$store.state.showFooter = !isCatalog;
    },
  },
  methods: {
    ...mapMutations(["toggleConfigurator", "navbarMinimize"]),
    closeModalCategory() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalCategory(); // Llama al método para cerrar el modal
      }
    },
    async submitCategory() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("categories/save", this.category);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getCategories();
              this.category.id = 0;
              this.category.name = '';
              this.category.parent_id = '';
              this.isEditingCategory = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editCategory(value) {
      this.isEditingCategory = true;
      this.category = {
        id: value.id,
        name: value.name,
        parent_id: value.parent_id,
      };

     
    },
    async cancelEditCategory() {
      this.isEditingCategory = false;
      this.category.id = 0;
      this.category.name = '';
      this.category.parent_id = '';
    },
    async getCategories() {
      const response = await this.$store.dispatch("categories/getCategories");
      this.categories = response.data;
      this.categories.sort((a, b) => a.fullname.localeCompare(b.fullname));
      this.parents = this.categories.filter(category => category.parent_id === null);
    },
    async deleteCategory(id) {
      const response = await this.$store.dispatch("categories/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getCategories();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }
    },
    async submitColor() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("colors/save", this.color);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getColors();
              this.color.id = 0;
              this.color.name = '';
              this.color.ref = '';
              this.isEditingColor = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editColor(value) {
      this.isEditingColor = true;
      this.color = {
        id: value.id,
        name: value.name,
        ref: value.ref,
      };
    },
    async cancelEditColor() {
      this.isEditingColor = false;
      this.color.id = 0;
      this.color.name = '';
      this.color.ref = '';
    },
    async getColors() {
      const response = await this.$store.dispatch("colors/getColors");
      this.colors = response.data;
    },
    async deleteColors(id) {
      const response = await this.$store.dispatch("colors/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getColors();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }
    },
    closeModalColors() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalColors(); // Llama al método para cerrar el modal
      }
    },
    async submitOficio() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("oficios/save", this.oficio);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getOficios();
              this.oficio.id = 0;
              this.oficio.name = '';
              this.oficio.description = '';
              this.oficio.status = 1;
              this.oficio.price = null;
              this.isEditingOficio = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editOficio(value) {
      this.isEditingOficio = true;
      this.oficio = {
        id: value.id,
        name: value.name,
        description: value.description,
        status: value.status,
        price: value.price ?? null,
      };

    },
    async getOficios() {
      const response = await this.$store.dispatch("oficios/getOficios");
      this.oficios = response.data;
    },
    async deleteOficios(id) {
      const response = await this.$store.dispatch("oficios/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getOficios();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalOficios() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalOficios(); // Llama al método para cerrar el modal
      }
    },
    cancelEditOficio() {
      this.isEditingOficio = false;
      this.oficio = { id: 0, name: '', description: '', status: 1, price: null };
    },
    async submitBodega() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("bodegas/save", this.bodega);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getBodegas();
              this.bodega.id = 0;
              this.bodega.name = '';
              this.bodega.description = '';
              this.bodega.status = 1;
              this.isEditing = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editBodega(value) {
      this.isEditing = true;
      this.bodega = {
        id: value.id,
        name: value.name,
        description: value.description,
        status: value.status,
      };
    },
    async cancelEditBodega() {
      this.isEditing = false;
      this.bodega.id = 0;
      this.bodega.name = '';
      this.bodega.description = '';
      this.bodega.status = 1;
    },
    async getBodegas() {
      const response = await this.$store.dispatch("bodegas/getAll");
      this.bodegas = response;
    },
    async deleteBodegas(id) {
      const response = await this.$store.dispatch("bodegas/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getBodegas();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalBodegas() {
      // Obtén el elemento del modal
      const modalElement = document.getElementById('ModalBodegas');
      // Obtén la instancia existente o crea una nueva
      let modalInstance = bootstrap.Modal.getInstance(modalElement);
      if (!modalInstance) {
        modalInstance = new bootstrap.Modal(modalElement);
      }
      // Cierra el modal
      modalInstance.hide();

      // Reinicia el formulario y el estado de edición
      this.bodega.id = 0;
      this.bodega.name = '';
      this.bodega.description = '';
      this.bodega.status = 1;
      this.isEditing = false;
    },

    async submitTalla() {
      try {
        // Dispara la acción de Vuex para guardar el estudiante
        const response = await this.$store.dispatch("tallas/save", this.sizeList);

        if (response && response.status >= 200 && response.status < 300) {
          await Swal.fire({
            icon: 'success',
            title: '¡Éxito!',
            text: 'El registro ha sido guardado correctamente.',
            confirmButtonText: 'Aceptar',
            backdrop: true,
          }).then((result) => {
            if (result.isConfirmed) {
              this.getTallas();
              this.sizeList.id = 0;
              this.sizeList.size = '';
              this.isEditingTalla = false;
            }
          });
        } else {
          throw new Error(response.data.message || 'Error al guardar el registro');
        }

      } catch (error) {
        console.error("Error al crear el registro:", error);
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: error.message || 'Error al guardar el registro',
        });
      }
    },
    async editTalla(value) {
      this.isEditingTalla = true;
      this.sizeList = {
        id: value.id,
        size: value.size,
      };
    },
    async cancelEditTalla() {
      this.isEditingTalla = false;
      this.sizeList.id = 0;
      this.sizeList.size = '';
    },
    async getTallas() {
      const response = await this.$store.dispatch("tallas/getAll");
      this.tallas = response;
    },
    async deleteTalla(id) {
      const response = await this.$store.dispatch("tallas/delete", id);

      if (response && response.status >= 200 && response.status < 300) {
        await Swal.fire(
          'Eliminado!',
          'El registro se ha sido eliminado correctamente.',
          'success'
        );
        this.getTallas();
      } else {
        await Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Error al eliminar el registro, esta asociado con otros registros',
        });
      }

    },
    closeModalTallas() {
      const configurator = this.$refs.configurator;
      if (configurator) {
        configurator.closeModalTallas(); // Llama al método para cerrar el modal
      }
    },
  },
  computed: {
    isCatalogRoute() {
      return this.$route.path.startsWith('/catalogo/');
    },
    navClasses() {
      return {
        "position-sticky bg-white left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && !this.$store.state.darkMode,
        "position-sticky bg-default left-auto top-2 z-index-sticky":
          this.$store.state.isNavFixed && this.$store.state.darkMode,
        "position-absolute px-4 mx-0 w-100 z-index-2": this.$store.state
          .isAbsolute,
        "px-0 mx-4": !this.$store.state.isAbsolute
      };
    }
  },
  beforeMount() {
    this.$store.state.isTransparent = "bg-transparent";
  },
  mounted() {

    let user = JSON.parse(localStorage.getItem('user'));

    // Verificar si el usuario existe
    if (user) {
      this.getCategories();
      this.getColors();
      this.getOficios();
      this.getBodegas();
      this.getTallas();
    } else {
      console.log("No se encontró un usuario en el localStorage.");
      // Opcional: redirigir al login o mostrar un mensaje
    }
  }
};
</script>
